import { Injectable } from '@angular/core';

import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from '../../app/services/app-helper.service';

@Injectable()
export class LearnerAuthGuard  {
    
    constructor(
        private authService: AuthService,
        private appHelperService: AppHelperService
    ){}

    canActivate() : boolean | Promise<boolean> {
        return this.authService.getUserDataFromSession().then(userData => {
            return this.authService.checkGigyaAndServerSession().then(()=> {
                if(userData) {
                    if(userData.role != 'student') {
                        this.appHelperService.navigateToDashboardApp([]);
                        return false;
                    } else {
                        return true;
                    }
                }  
                else {
                    this.authService.rurl =  window.location.pathname + window.location.search;
                    return false;
                }
            });
        });
    }
    
}